import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import Icon from "../icon/icon.component.jsx";
import { PlaidLink, usePlaidLink } from 'react-plaid-link';
import ActionButton from "../button/actionbutton.component.jsx";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

const messages = defineMessages({
    card_number_placeholder: {
        id: 'credit_card.paysafe.card_number_placeholder',
        defaultMessage: 'Card number',
    },
    expiry_date_placeholder: {
        id: 'credit_card.paysafe.expiry_date_placeholder',
        defaultMessage: 'MM / YY',
    },
    cvc_placeholder: {
        id: 'credit_card.paysafe.cvc_placeholder',
        defaultMessage: 'CVC',
    },
    cardholder_name_placeholder: {
        id: 'credit_card.paysafe.cardholder_name_placeholder',
        defaultMessage: 'Cardholder name',
    },
    postal_code_placeholder: {
        id: 'credit_card.paysafe.postal_code_placeholder',
        defaultMessage: 'Postal code',
    },
})

class PlaidBankAccountForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            token: '',
            institutionName: '',
            mask: '',
            accountName: '',
            bankAccountId: '',
            proposalHash: this.props.proposalHash || '',
            countryCode: this.props.countryCode || 'US',
            testMode: this.props.testMode || false,
            apiKey: '',
            onSubmit: this.props.onSubmit || function () { },
            submitButtonStyle: this.props.submitButtonStyle || {},
            submitButton: this.props.submitButton || <FormattedMessage
                id="common.credit_card.confirm_label"
                defaultMessage="Confirm"
            />,
            submitButtonLoading: false,
            submitDisabled: this.props.submitDisabled || false,
            amount: this.props.amount || '0',
            currency: this.props.currency,
            companyName: this.props.companyName,
            creditCardType: <Icon value={'credit-card'} />,
        }

        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleResult = this.handleResult.bind(this)
        this.handlePay = this.handlePay.bind(this)
        this.reloadApiKey = this.reloadApiKey.bind(this)
    }

    componentDidMount() {
        this.reloadApiKey()
        setInterval(this.reloadApiKey, 5000)
    }

    reloadApiKey() {
        if (this.state.expirationDate) {
            const expirationDate = new Date(this.state.expirationDate)
            const now = new Date()
            if (expirationDate > now) {
                return
            }
        }
        AppContext.getApiClient().post(`/proposals/${this.state.proposalHash}/pre-payment-token`, {
            paymentType: 'bank-transfer',
            currency: this.state.currency,
        }).then(res => {
            if (!res.error) {
                this.setState({
                    apiKey: res.id,
                    expirationDate: res.attributes.expirationDate
                })
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            submitDisabled: nextProps.submitDisabled || false,
            testMode: nextProps.testMode || false,
            amount: nextProps.amount || '0',
            currency: nextProps.currency,
            proposalHash: nextProps.proposalHash || '',
            merchantId: nextProps.merchantId,
        })
    }

    handleSubmit(publicToken, metadata) {
        // Send the public_token and account ID to your app server.
        const account = metadata.accounts[0] || {}
        this.setState({
            token: publicToken,
            bankAccountId: metadata.account_id,
            institutionName: metadata.institution.name,
            mask: account.mask,
            accountName: account.name,
        })
    }

    handlePay(event) {
        event.preventDefault()
        this.state.onSubmit({
            token: this.state.token,
            last4: this.state.mask,
            bankAccountId: this.state.bankAccountId,
        }, () => {
            this.setState({
                submitButtonLoading: false,
            })
        })
    }

    handleResult(instance, error, result) {
        const token = result ? result.token : null
        if (error) {
            error.message = error.detailedMessage
        }
        this.state.onSubmit({
            id: token,
            billingDetails: {
                name: this.state.name,
                address: {
                    postalCode: this.state.postalCode,
                    countryCode: this.state.countryCode,
                }
            }
        }, error, () => {
            this.setState({
                submitButtonLoading: false,
            })
        })
    }

    render() {
        const plaidConfig = {
            clientName: this.state.companyName,
            env: this.state.testMode ? 'sandbox' : 'production',
            token: this.state.apiKey,
        }
        if (!this.state.apiKey) {
            return <div />
        }
        return (
            <div className={'row'}>
                {this.state.token ? <div className={'col-12'}>
                    <div className={'w-100 d-flex align-items-center'}>
                        <h2 className={'mr-3'}>
                            <Icon value={'university'} />
                        </h2>
                        <div className={'flex-fill'}>
                            <div className={'w-100 d-flex justify-content-between'}>
                                <pre className={'mb-0'} style={{ fontSize: '100%' }}><strong>{this.state.accountName}</strong></pre>
                                <pre className={'mb-0'} style={{ fontSize: '100%' }}>
                                    <Icon value={'ellipsis-h'} />
                                    <Icon value={'ellipsis-h'} className={'mr-1'} />
                                    <span>{this.state.mask}</span>
                                </pre>
                            </div>
                            <div className={'w-100 d-flex justify-content-between'}>
                                <pre className={'mb-0'} style={{ fontSize: '100%' }}>{this.state.institutionName}</pre>
                                <div>
                                    <PlaidLink
                                        {...plaidConfig}
                                        className="btn btn-sm btn-link"
                                        style={{
                                            background: 'inherit'
                                        }}
                                        onSuccess={this.handleSubmit}
                                    >
                                        <Icon value={'edit'} className={'mr-1'} />
                                        <FormattedMessage
                                            id="common.bank_account.stripe.change_account"
                                            defaultMessage="Change"
                                        />
                                    </PlaidLink>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'w-100 mt-3'}>
                        <ActionButton
                            type="button"
                            className="btn btn-primary w-100 pay"
                            style={this.state.submitButtonStyle}
                            disabled={this.state.submitDisabled}
                            isLoading={this.state.submitButtonLoading}
                            onClick={this.handlePay}
                        >
                            {this.state.submitButton}
                        </ActionButton>
                    </div>

                </div> : <div className={'col-12'}>
                    <PlaidLink
                        {...plaidConfig}
                        type="button"
                        className="btn btn-primary w-100 pay"
                        style={this.state.submitButtonStyle}
                        disabled={this.state.submitDisabled}
                        onSuccess={this.handleSubmit}
                    >
                        <FormattedMessage
                            id="common.bank_account.stripe.select_account"
                            defaultMessage="Select a bank account"
                        />
                    </PlaidLink>
                </div>}
                {this.props.children}
            </div>
        )
    }
}

export default injectIntl(PlaidBankAccountForm)





// WEBPACK FOOTER //
// ./src/common/bank-account/plaid.component.jsx